import { render, staticRenderFns } from "./copper.vue?vue&type=template&id=f46dead8&scoped=true"
import script from "./copper.vue?vue&type=script&lang=js"
export * from "./copper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46dead8",
  null
  
)

export default component.exports